var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0046 16C6.42235 16 4.87563 15.5308 3.56004 14.6518C2.24444 13.7727 1.21906 12.5233 0.613562 11.0615C0.00806067 9.59966 -0.150368 7.99113 0.158314 6.43928C0.466996 4.88743 1.22892 3.46197 2.34775 2.34315C3.46657 1.22433 4.89203 0.462403 6.44388 0.153721C7.99573 -0.15496 9.60425 0.00346646 11.0661 0.608968C12.5279 1.21447 13.7773 2.23985 14.6564 3.55544C15.5354 4.87103 16.0046 6.41775 16.0046 8C16.0022 10.121 15.1585 12.1544 13.6588 13.6542C12.159 15.1539 10.1256 15.9976 8.0046 16ZM8.0046 0.845009C6.58928 0.844101 5.20548 1.26296 4.02824 2.04861C2.85101 2.83426 1.93322 3.9514 1.39097 5.25872C0.848723 6.56605 0.706373 8.00482 0.981931 9.39306C1.25749 10.7813 1.93858 12.0566 2.93904 13.0577C3.9395 14.0588 5.21439 14.7407 6.60245 15.0172C7.9905 15.2936 9.42937 15.1522 10.737 14.6108C12.0447 14.0694 13.1624 13.1523 13.9488 11.9756C14.7353 10.7989 15.155 9.41532 15.155 8C15.1526 6.10392 14.3986 4.28613 13.0583 2.94496C11.718 1.6038 9.90068 0.848654 8.0046 0.845009Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08038 3.96327L12.2893 7.55914C12.3723 7.60432 12.4418 7.67055 12.491 7.75118C12.5402 7.8318 12.5673 7.92397 12.5695 8.01838C12.5655 8.11239 12.5377 8.20383 12.4887 8.28416C12.4397 8.36448 12.3711 8.43105 12.2893 8.47762L6.08956 12.0735C6.00364 12.1253 5.90518 12.1527 5.80483 12.1527C5.70447 12.1527 5.60602 12.1253 5.5201 12.0735C5.44799 12.0208 5.38953 11.9516 5.34958 11.8717C5.30964 11.7918 5.28938 11.7036 5.29048 11.6142V4.43629C5.29048 4.43629 5.30426 3.51321 6.08038 3.96327Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a855657a4da950dadab6ec25954659b3.svg";
export { ForwardRef as ReactComponent };